module.exports = __webpack_public_path__ + "img/circle-z.b96cfb03.svg";